import * as angular from 'angular';
import * as _ from 'underscore';
import { EnumService } from '../../../app.common/modules/common/services/enum.service';
import { CampaignListItem, Campaign } from '../../../app.retailer/modules/core';
import { RetailerServiceBase } from './retailer.service';
import { ICampaignListItem, ICampaign } from '../../../app.retailer/modules/campaigns/models';


export class CommonCampaignsService {
    static $inject = ['enumService', 'commonRetailerService', '$translate'];

    previewImgSize = {
        w: 320,
        h: 160
    };

    daysOfWeek = [
        { key: 0, name: this.$translate.instant('sunday'), selected: false, order: 7 },
        { key: 1, name: this.$translate.instant('monday'), selected: false, order: 1 },
        { key: 2, name: this.$translate.instant('tuesday'), selected: false, order: 2 },
        { key: 3, name: this.$translate.instant('wednesday'), selected: false, order: 3 },
        { key: 4, name: this.$translate.instant('thursday'), selected: false, order: 4 },
        { key: 5, name: this.$translate.instant('friday'), selected: false, order: 5 },
        { key: 6, name: this.$translate.instant('saturday'), selected: false, order: 6 }
    ];

    constructor(
        private enumService: EnumService,
        private commonRetailerService: RetailerServiceBase,
        private $translate: angular.translate.ITranslateService) { }

    getDateTime = (dateStr: string, stringTime: string) => {
        let date = new Date();
        if (dateStr) {
            date = new Date(dateStr);
        }
        if (_.isString(stringTime)) {
            var time = stringTime.split(':');
            if (time.length >= 2) {
                var hour = parseInt(time[0], 10);
                var minute = parseInt(time[1], 10);
                return new Date(date.getFullYear(), date.getMonth(), date.getDate(), hour ? hour : 0, minute ? minute : 0, 0, 0);
            }
        }
        return date;
    }

    getTimeString = (allDay: boolean, time: Date) => {
        if (allDay) {
            time = this.getDateTime(null, '00:00');
        }
        if (time instanceof Date) {
            var hours = time.getHours();
            var minutes = time.getMinutes();
            return (hours < 10 ? '0' + hours : hours) + ':' +
                (minutes < 10 ? '0' + minutes : minutes);

        } else {
            return '';
        }
    }

    getDaysOfWeek = () => {
        return this.daysOfWeek;
    }

    getBitArrayByNumber = (number: number) => {
        // needed since toString does not zero fill on left
        var template = '0000000';
        // toString converts a number to a bitstring
        var bit = number.toString(2);
        return template.substring(0, template.length - bit.length) + bit;
    }

    getSelectdaysOfWeek = (number: number): string => {
        if (number == null) {
            return 'day';
        }
        var numberBit = this.getBitArrayByNumber(number).split('').reverse().join('');
        var daysOfWeek = this.getDaysOfWeek();
        var arrayDaysName = [];
        var selectedDaysOfWeek = [];
        for (var c = 0; c < numberBit.length; c++) {
            if (numberBit[c] === '1') {
                selectedDaysOfWeek.push(daysOfWeek[c]);
                arrayDaysName.push(daysOfWeek[c].name);
            }
        }
        selectedDaysOfWeek = _.sortBy(selectedDaysOfWeek, 'order');
        arrayDaysName = _.pluck(selectedDaysOfWeek, 'name');
        var daysOfWeekString;
        if (arrayDaysName.length > 1) {
            daysOfWeekString = arrayDaysName.slice(0, arrayDaysName.length - 1).join(', ');
            daysOfWeekString += ' and ' + arrayDaysName[arrayDaysName.length - 1];
        } else {
            daysOfWeekString = arrayDaysName.length === 0 ? 'day' : arrayDaysName[0];
        }

        return daysOfWeekString;
    }

    getCampaignStatus = () => {
        return this.enumService.CampaignStatus;
    }

    getVideoStatus = () => {
        return this.enumService.VideoStatus;
    }

    adaptCampaignData = (campaign) => {
        if (!campaign) {
            return;
        }
        campaign.StartDate = campaign.StartDate ? new Date(campaign.StartDate) : null;
        campaign.EndDate = campaign.EndDate ? new Date(campaign.EndDate) : null;
        campaign.Image = campaign.ImageID ? this.commonRetailerService.getCampaignImageUrl(campaign.ImageID) : null;
        campaign.Video = campaign.VideoID ? this.commonRetailerService.getCampaignThumbnailImageUrl(campaign.VideoID, this.previewImgSize.w, this.previewImgSize.h) : null;
        campaign.weeksdays = this.getSelectdaysOfWeek(campaign.DaysOfWeek);
        campaign.archived = campaign.Status === this.enumService.CampaignStatus.Archived || campaign.Status === this.enumService.CampaignStatus.Completed;
    }
}

angular
    .module('app.retailes.common')
    .service('commonCampaignsService', CommonCampaignsService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer.common/modules/services/commonCampaigns.service.ts